import React, { useState } from 'react';
import { Box, Button, Heading, Span, VStack } from '@bpba/ui-components';
import { useForm, SubmitHandler } from 'react-hook-form';
import { ArrepentimientoIndex } from '../rest/models/ArrepentimientoIndex';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { ArrepentimientoIndexApiRQ } from '../rest/models/ArrepentimientoIndexApiRQ';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { postArrepentimientoIndexSP } from '../rest/mutations/postArrepentimientoIndexSP';
import { Result } from './Result';
import { ResultError } from './ResultError';

const validateRealCuit = (cuit: string) => {
    let rv = false;
    if (cuit.length === 8 || cuit.length === 7) {
        const validarDni = /^[0-9]{1,3}\.?[0-9]{3,3}\.?[0-9]{3,3}$/;
        rv = validarDni.test(cuit)
    }
    else {
        let resultado = 0;
        const codes = "6789456789";
        let verificador = parseInt(cuit[cuit.length - 1]);
        let x = 0;

        while (x < 10) {
            let digitoValidador = parseInt(codes.substring(x, x + 1));
            if (isNaN(digitoValidador)) digitoValidador = 0;
            let digito = parseInt(cuit.substring(x, x + 1));
            if (isNaN(digito)) digito = 0;
            let digitoValidacion = digitoValidador * digito;
            resultado += digitoValidacion;
            x++;
        }
        resultado = resultado % 11;
        rv = resultado === verificador;
    }
    return rv ? rv : "Verifique el Cuit ingresado";
};

const ArrepentimientoIndexComponente: React.FC = () => {


    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [errorServicio] = useState<boolean>(false);
    const [mensajeError] = useState<string>("");
    const { register, handleSubmit, getValues, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange'
    });
    const REQUIRED_FIELD = "Campo requerido.";
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [postArrepentimientogIndexApi, { loading: loadingArrepentimiento }] = useMutation<Mutations>(postArrepentimientoIndexSP);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>(<></>);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");


    const onSubmit: SubmitHandler<ArrepentimientoIndex> = async (data: ArrepentimientoIndex) => {

        const token = executeRecaptcha && (await executeRecaptcha('Arrepentido'));

        if (data.confEmail === data.email) {
            let datos: ArrepentimientoIndexApiRQ = {
                "googleToken": token,
                "cuit": data.cuit.toString(),
                "email": data.email,
                "razonSocial": "."
            }
            await postArrepentimientogIndexApi({ variables: { input: datos } }).then(response => {

        
                if (response !== null || response !== undefined) {

                    if (response.data?.ArrepentimientoIndexApiRS.resultado === 'ok') {
                
                        setServicioOk(true);
                        setMensajeRtaServicio("Solicitud creada con éxito. En los próximos días nos contactaremos con vos.");
                    }  else if(response.data?.ArrepentimientoIndexApiRS.resultado === 'error'){
                  
                        if (response.data?.ArrepentimientoIndexApiRS.error.includes('existe')) {
                            setServicioOk(true);
                            setMensajeRtaServicio("Ya existe un registro con este cuit");
                        } 
                        else {
                            setServicioOk(true);
                            setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                        }
                    }else {
                        setServicioOk(true);
                        setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                    }

               
                } 
                
            }).catch((e) => {
        
                if (e.networkError.statusCode === 500) {
                    setServicioOk(false);
                    setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");

                }
                else if (e.networkError.statusCode === 409) {
                    setServicioOk(false);
                    setMensajeErrorPostProspecto(JSON.parse(JSON.stringify(e.networkError)).result.Message);

                } else {
                    setServicioOk(false);
                    setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
                }
            })
        } else {
            return "Los emails no coinciden";
        }



    }

    if (loadingArrepentimiento) return <SpinnerCajas />;

    const handleReset = () => {
        reset({});
        window.location.reload();
    };


    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} color="primary.0" tabIndex={0}>{mensajeRtaServicio}</Heading>
            </VStack>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );

    return (

        <Box>
            <VStack>
                <form noValidate onSubmit={handleSubmit(onSubmit)} style={{ minHeight: '400px', display: "flex", flexDirection: "column", marginBottom: "4rem" }}>

                    <Heading level={3} mb={'20px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                        </VStack> : <></>
                    }

                    <input type={"text"} tabIndex={0}
                        {...register("cuit", {
                            required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                            maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                        })}
                        name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} />
                    <Span fontSize={"12px"} tabIndex={0}>
                        *ingresar el CUIT sin guiones
                    </Span>
                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                        {errors.cuit ? "* " + errors.cuit.message : ""}
                    </Span>

                    <VStack mt={"10px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>

                    <VStack  mt={"20px"}>
                        <input type={'text'} placeholder='Confirmación E-mail' maxLength={100} {...register("confEmail", {
                            required: REQUIRED_FIELD, validate: (value) => getValues("email") === value || "Los emails no coinciden"
                        })} name="confEmail" autoComplete="off" />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.confEmail ? "* " + errors.confEmail.message : ""}</Span>
                    </VStack>


                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>

                </form>
            </VStack>

        </Box>

    )

};



export default ArrepentimientoIndexComponente;
